import React from "react";
import GaugeChart from "react-gauge-chart";

const ScoreGauge = ({ score, width }) => {
  return (
    <div style={{ width: `${width ?? '100px'}`, margin: "0 auto" }}>
      <GaugeChart
        id="score-gauge"
        nrOfLevels={20}
        percent={score / 100} // convert score to 0–1
        textColor="#ffffff00"
        arcColors={["#FF5F6D", "#FFC371", "#00C9A7"]}
      />
      {/* <h3 style={{ textAlign: "center" }}>{score}%</h3> */}
    </div>
  );
};

export default ScoreGauge;